const HIDE_MASTER_COURSE_WELCOME_MODAL_KEY = 'hide-sync-course-welcome-modal';

import CategoryType from '@/helpers/contentCategory';
import { ACADEMIC_SYNC_TYPE } from '~/helpers/contentSync';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      syncSummaryContentsHeaders: [
        { text: this.$t('content.modalContentSync.syncSummary.contentTypes.table.contentType'), value: 'name', sortable: false, width: '70%' },
        { text: this.$t('content.modalContentSync.syncSummary.contentTypes.table.amount'), value: 'amount', sortable: false, width: '30%' }
      ],
      syncSummaryListDetail: {
        isOpen       : false,
        modalWidth   : '600',
        modalTitle   : '',
        tableHeaders : [],
        tableItems   : []
      }
    };
  },
  computed: {
    ...mapGetters({
      getterCourse  : 'plataforma/newContent/getterCourse',
      getterContent : 'plataforma/newContent/getterContent'
    }),
    isMasterCourse() {
      const academicMainSyncTypeId = this.$route.params.id ? this.getterContent.context?.academicSyncTypeId : this.getterCourse?.context?.academicSyncTypeId;
      return academicMainSyncTypeId === ACADEMIC_SYNC_TYPE.MASTER;
    },
    isAssociatedCourse() {
      const academicMainSyncTypeId = this.$route.params.id ? this.getterContent.context?.academicSyncTypeId : this.getterCourse?.context?.academicSyncTypeId;
      return academicMainSyncTypeId === ACADEMIC_SYNC_TYPE.ASSOCIATE;
    }
  },
  methods: {
    _getHideSyncCourseWelcomeModalData() {
      const data = JSON.parse(localStorage.getItem(HIDE_MASTER_COURSE_WELCOME_MODAL_KEY));

      return !data ? {} : data;
    },
    _setHideSyncCourseWelcomeModalData(data) {
      localStorage.setItem(HIDE_MASTER_COURSE_WELCOME_MODAL_KEY, JSON.stringify(data));
    },
    userHasHiddenSyncCourseWelcomeModal(userId, academicMainId) {
      const localStorageData = this._getHideSyncCourseWelcomeModalData();
      const userData = localStorageData[userId] || [];

      return userData.includes(Number(academicMainId));
    },
    saveHideSyncCourseWelcomeModal(userId, academicMainId) {
      let localStorageData = this._getHideSyncCourseWelcomeModalData();
      const userData = localStorageData[userId] || null;

      if (!userData) {
        if (Object.keys(localStorageData).length > 0) {
          localStorageData[userId] = [academicMainId];
        } else {
          localStorageData = {
            [userId]: [academicMainId]
          };
        }

        this._setHideSyncCourseWelcomeModalData(localStorageData);
        return;
      }

      const hasAlreadyHiddenForAcademicMain = userData.includes(academicMainId);
      if (!hasAlreadyHiddenForAcademicMain) {
        userData.push(academicMainId);
      }

      this._setHideSyncCourseWelcomeModalData(localStorageData);
    },
    getTotalSyncContents(topics) {
      const invalidCategoryTypes = [
        CategoryType.AVALIA,
        CategoryType.WEBCONFERENCE,
        CategoryType.H5P,
        CategoryType.SCORM
      ];

      return topics.reduce((total, topic) => {
        if (topic.children && topic.children.length) {
          const countChildren = (children) => {
            return children.reduce((count, child) => {
              let newCount = count;

              if (!invalidCategoryTypes.includes(child.categoryTypeId)) {
                newCount += 1;
              }

              if (child.children && child.children.length) {
                newCount += countChildren(child.children);
              }

              return newCount;
            }, 0);
          };

          return total + (!invalidCategoryTypes.includes(topic.categoryTypeId) ? 1 : 0) + countChildren(topic.children);
        }

        return !invalidCategoryTypes.includes(topic.categoryTypeId) ? total + 1 : total;
      }, 0);
    },
    getCategoryCounts(topics) {
      const invalidCategoryTypes = [
        CategoryType.AVALIA,
        CategoryType.WEBCONFERENCE,
        CategoryType.H5P,
        CategoryType.SCORM
      ];

      const categoryCounts = topics.reduce((acc, topic) => {
        const processTopic = (currentTopic) => {
          const categoryId = currentTopic.categoryTypeId;
          if (!invalidCategoryTypes.includes(categoryId)) {
            if (!acc[categoryId]) {
              acc[categoryId] = { id: categoryId, name: this.$t(CategoryType.getCategoryI18NKeyById(categoryId)), amount: 0 };
            }
            acc[categoryId].amount += 1;
          }

          if (currentTopic.children && currentTopic.children.length) {
            currentTopic.children.forEach(processTopic);
          }
        };

        processTopic(topic);
        return acc;
      }, {});

      return Object.values(categoryCounts);
    },
    getSyncSummaryListDetailData(data) {
      this.syncSummaryListDetail = {
        isOpen: true,
        ...data
      };
    },
    resetSyncSummaryListDetail() {
      this.syncSummaryListDetail = {
        isOpen       : false,
        modalTitle   : '600',
        tableHeaders : [],
        tableItems   : []
      };
    },
    async handleOpenSyncAssociatedCourses() {
      this.$nuxt.$loading.start();

      try {
        const result = await this.$services.contentV2().getSyncSummary({ academicMainId: this.getterCourse.context.academicMainId });
        this.getSyncSummaryListDetailData({
          modalTitle : this.$tc('content.layout.timeline.course.associatedCourses', 2),
          modalWidth : '750',
          tableItems : result.data.associatedAcademicMains,
          type       : 'associatedCourses'
        });
      } catch (error) {
        this.$toast.error(this.$t('content.modalContentSync.syncSummary.errorFetchingSyncData'));
      } finally {
        this.$nuxt.$loading.finish();
      }
    }
  }
};
